
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic04 as ObiHydraulic04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-04.js';
 
 
 

 
 export const ObiHydraulic04 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-04',
   elementClass: ObiHydraulic04Element,
   events: {
     
   }
  });
 
 